<template>
  <div id="delivery" style="box-shadow: rgba(0, 0, 0, 0.3) 0px 20px 22px 0px;">
    <div :class="!hasDisposition && 'dynamic-localization'">
      <div class="xs-flex text-glitch-fix" v-if="!hasDisposition">
        <div data-item-id="localisation-delivery" data-item-type="tool" data-item-position="1"
          data-synth="form-delivery" data-type="DELIVERY"
          class="order-type-button xs-flex-center xs-flex-auto xs-min-width-0 xs-p-10 bold rounded-top no-outline xs-nowrap text-glitch-fix "
          v-bind:class="isDeliveryClass" role="button" style="margin-right: 2px; font-size: 16px; height: 75px;" tabindex="0"
          v-on:click="clickActiveDelivery">
          <i class="icon-delivery xs-mr-5 xs-hide md-block"></i>
          <span>{{$t('delivery')}}</span>
        </div>
        <div data-item-id="localisation-takeaway" v-if="!isLanding" data-item-type="tool" data-item-position="2"
          data-synth="form-collection" data-type="CARRYOUT"
          class="order-type-button xs-flex-center xs-flex-auto xs-min-width-0 xs-p-10 bold rounded-top no-outline xs-nowrap text-glitch-fix"
          v-bind:class="isCollectionClass" role="button" style="font-size: 16px; height: 75px;" tabindex="0"
          v-on:click="() => clickActiveCollection(false)">
          <i class="icon-collection xs-mr-5 xs-hide md-block"></i>
          <span v-html="$t('collection')" class="text-center"></span>
        </div>
      </div>
      <div class="localisation xs-fill-white xs-p-15" v-if="!hasDisposition">
        <div v-if="$auth.check()">
          <div v-if="customerInfo.list_address && customerInfo.list_address.length > 0">
            <h2 class="mb-30">{{$t('welcome_back',{name : $auth.user().first_name})}}</h2>
            <div class="mb-15">
              <v-select v-if="orderType === $const.DELIVERY"
                :placeholder="$t('placeholder_dropdown_delivery')" :multiple="false"
                :options="customerInfo.list_address" class="select-localization-variant-2"
                @input="selectSaveAddress">
                <template v-slot:option="option">
                  <div class="dropdown-title pt-5 pb-5"><strong>{{ option.label }}</strong></div>
                </template>
              </v-select>
              <v-select v-else :placeholder="$t('placeholder_dropdown_collection')" :multiple="false"
                :options="customerInfo.list_store" class="select-localization-variant-2"
                @input="selectStore">
                <template v-slot:option="option">
                  <div class="dropdown-title pt-5 pb-5"><strong>{{ option.label }}</strong></div>
                </template>
              </v-select>
            </div>
          </div>
        </div>
        <div v-if="warningDisposition" class="xs-pb-15 xs-fill-yellow xs-text-black xs-p-10 xs-mb-10 arrow-bottom-yellow typo-l6b warning-disposition" style="display: block;">
          <span v-if="orderType === $const.CARRYOUT" class="carryout">{{$t('localization.popup_carryout')}}</span>
          <span v-else class="delivery">{{$t('localization.popup_delivery')}}</span>
        </div>
        <div class="xs-border pb-10 rounded">
          <div class="xs-flex xs-items-end xs-relative xs-z-300 xs-fill-white xs-mb-10 xs-items-center localisation-search-box">
            <div class="xs-flex-1">
              <input v-if="orderType === $const.CARRYOUT"
                class="search search--hut input xs-border-none xs-py-10 xs-px-10" id="address-autocomplete"
                data-synth="address-input" name="address" autocomplete="off" autocorrect="off" autocapitalize="off"
                v-bind:placeholder="$t('localization.placehover_search_by_address_carryout')"
                spellcheck="false" value="" type="text" v-model="searchAutoComplete"
                ref="autoComplete">
              <input v-else class="search search--hut input xs-border-none xs-py-10 xs-px-10" id="address-autocomplete"
                data-synth="address-input" name="address" autocomplete="off" autocorrect="off" autocapitalize="off"
                spellcheck="false" v-bind:placeholder="$t('localization.placehover_search_by_address')" value=""
                type="text" v-model="searchAutoComplete"
                ref="autoComplete">
            </div>
            <a href="javascript: void(0)" v-if="searchAutoComplete.length > 0">
              <button class="flex-1 t13 pl-10 pr-10" @click="clearTextSearch">
                <img src="../../assets/images/icons/delete.png"/>
              </button>
            </a>
            <div>
              <a href="javascript: void(0)" data-item-id="localisation-submit" data-item-type="tool"
                data-item-position="3" class="button button--primary flex-1"
                style="border-radius: 3px;" @click="searchDelivery">
                <span class="flex w-full flex-col  t14">{{$t('button_search')}}</span>
              </a>
            </div>
          </div>
          <button data-item-id="localisation-auto" data-item-type="tool" data-item-position="4"
            v-if="searchAutoComplete.length <= 0 && orderType === $const.CARRYOUT"
            class="trigger-location use-current-location flex xs-items-center"
            v-on:click="useMyLocation"
            style="color: #4a90e2"><i class="icon-geo mr-10"></i> {{$t('using_my_local_carryout')}}
          </button>
          <button v-else class="trigger-location use-current-location flex xs-items-center" @click="openGGMap" style="color: #4a90e2">
            <i class="icon-geo mr-10"></i>{{$t('localization.or_use_my_current_location')}}
          </button>
        </div>
        <div class="clearfix"></div>
        <a href="javascript:void(0)" class="cursor-pointer cl-78838c border-b t13 mt-10 mb-10 pull-right decoration-none" v-if="outletList.length > 1" @click="() => showHideMap(mapOpen)">{{ $t('button_open_maps')}}</a>
        <div class="clearfix"></div>
        <div class="container-outlet">
          <ul class="list-outlets" v-if="outletList.length > 0 && orderType === $const.CARRYOUT">
            <li v-for="(outlet,index) in outletList" :key="index" class="outlet-item inactive text-black" v-bind:class="{highlight: index === highlight}" @click="() => beforeClickChosenOutlet(outlet)">
              <h4> {{index +1}}. <span class="text-capitalize">{{outlet.name}} <span class="t12"> ( {{formatNum(outlet.distance)}} km )</span></span>
              </h4>
              <p>{{outlet.address}}</p>
            </li>
          </ul>
        </div>
        <div class="clearfix"></div>
        <div v-if="outletList.length <= 0 && message.length > 0" class="pt-10">
          <div class="flex1 display-flex items-center mb-0">
            <img src="https://static.phdvasia.com/jp/icons/error.svg" width="20" class="" style="height:20px; flex: 0 0 30px;">
            <span style="">{{message}}</span>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>

      <div class="xs-p-20 localisation xs-fill-fcfcfc rounded-bottom xs-fill-white text-center" v-if="hasDisposition">
        <div class="xs-mb-20">
          <div>
            <p>
              <span class="t14">{{$disposition.getByKey(this, 'orderType', '') === $const.DELIVERY ? $t('delivery_to') : $t('take_away')}}</span>
              <strong class="border-b uppercase">
                {{ getDeliveryInfo(this).addressInfo }}
              </strong>
            </p>
          </div>
          <button class="btn btn-default w-full bg t16" style="min-height: 42px; background-color: #cccccc45" @click="resetDisposition"> {{$t('button_change')}}
          </button>
        </div>
        <div>
          <button v-on:click="viewMenu" class="btn btn-success w-full font-bold t16" style="min-height: 42px">
            {{$t('home.button_view_all_pizza')}}
          </button>
        </div>
      </div>
    </div>
    <div v-if="!hasDisposition" class="xs-fill-white p-15">
      <div v-if="msgLocalization" class="localisation alert-danger mb-15" style="padding: 10px; border-radius: 4px;">
        <i class="fa fa-fw fa-lg fa-exclamation-circle"></i>
        <span ref="errorLocalisation" id="errorLocalisation" style="color: #6a6a6a" v-html="msgLocalization"></span>
      </div>
      <div class="container-map bg-white inactive text-black" v-show="orderType !== $const.CARRYOUT">
        <div v-show="showMapDelivery">
          <div style="margin-bottom: 10px">
            <div class="button-order-datetime pb-5 pt-15 pl-0 pr-0" style="display: block; margin-bottom: 10px;">
              <div class="xs-flex xs-items-end">
                <button class="button button--primary xs-flex-1 save-disposition " @click="orderNow" data-synth="button--delivery" type="button">
                  <div class="xs-flex xs-full-width xs-flex-column xs-py-10">
                    <span class="bold">{{$t('order_now')}}</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
          <div id="map-delivery" style="height: 500px; width: 100%"></div>
        </div>
      </div>
      <div v-if="msgLocalization && showPopupTime && !showMapDelivery" class="xs-fill-white">
        <div class="pb-10">
          <button class="btn btn-success w-full mt-15" style="min-height: 42px" @click="() => handleAction()">
            {{$t('btn_pre_order')}}
          </button>
          <button class="w-full text-green" style="min-height: 42px;" @click="() => changeAddress()">
            {{$t('button_change')}}
          </button>
        </div>
      </div>
      <div class="text-center pb-10" v-if="isSearchAddress">
        <i class="fa fa-refresh fa-spin" style="height: 14px; width: 14px; background-size: 14px;"></i>
      </div>
      <div v-if="dataDate && dataTime.length > 0" class="localization-timeslot localisation xs-fill-white">
        <div class="localization-timeslot-title font-sharp-sans-bold">{{$t('what_time_would_you_like_your_order')}}</div>
        <div class="time-slots">
          <select class="select-popup-date-time t16 arrow-dropdown-time mr-5" v-model="choiceDay">
            <option v-for="(item, i) in dataDate" :key="i" :value="item.value" class="option-time-slots">
              {{ item.label }}
            </option>
          </select>
          <select class="select-popup-date-time t16 arrow-dropdown-time ml-5" v-model="choiceHour">
            <option v-for="(item, i) in dataTime" :key="i" :value="item.value" class="option-time-slots">
              {{ item.label }}
            </option>
          </select>
        </div>
        <button class="btn btn-success w-full mt-15" style="min-height: 42px" @click="() => selectTimeSlot()">
          {{$t('btn_pre_order')}}
        </button>
        <button class="w-full text-green" style="min-height: 42px;" @click="() => changeAddress()">
          {{$t('button_change')}}
        </button>
      </div>
      <div v-if="(switchToCollection || switchToDelivery) && !showPopupTime" class="xs-fill-white">
        <button v-if="switchToCollection" class="btn btn-success w-full" style="min-height: 42px" @click="() => clickActiveCollection()">
          {{$t('btn_switch_to_collection')}}
        </button>
        <button v-if="switchToDelivery" class="btn btn-success w-full" style="min-height: 42px" @click="() => clickActiveDelivery()">
          {{$t('btn_switch_to_delivery')}}
        </button>
      </div>
      <div v-if="msgGeo" class="xs-fill-white mt-15">
        <div class="geo-message-content">
          <i class="fa fa-exclamation-circle fa-lg icon-noti-geo mr-5"></i>
          <div class="geo-message">
            <div class="geo-message-title font-sharp-sans-bold pb-5">{{$t('geo_notification_title')}}</div>
            <div class="geo-message-body">{{msgGeo}}</div>
          </div>
        </div>
        <button class="btn btn-success w-full mt-15" style="min-height: 42px" @click="useMyLocation">
          {{$t('btn_geo_ask_open')}}
        </button>
        <button class="w-full text-green" style="min-height: 42px;" @click="msgGeo = ''">
          {{$t('btn_geo_not_now')}}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import ModalConfirm from '../popup/ModalConfirm.vue'
import ModalCarryout from '../popup/ModalCarryout.vue'
import ModalWarning from '../popup/ModalWarning.vue'
import ModalMap from '../popup/ModalMaps.vue'
import ModalMapDelivery from '../popup/ModalMapDelivery'
import MaskedInput from 'vue-masked-input'
import vSelect from 'vue-select'
import {mapGetters, mapActions} from 'vuex'
import * as action from '../../store/actions'
import moment from 'moment-timezone'

export default {
  name: 'HomeLocalization',
  props: {
    isLanding: false,
    routeLanding: false,
    isPopup: false,
    callBackNameSeo: '',
    isSubCategory: {
      type: [Boolean, String],
      default: false
    }
  },
  components: {
    MaskedInput,
    vSelect
  },
  computed: {
    ...mapGetters({
      warningDisposition: 'warningDisposition'
    })
  },
  watch: {
    searchAutoComplete: function (newValue, _oldValue) {
      if (!newValue) {
        this.clearTextSearch()
      }
      if (!this.keepCurrentLocation) {
        this.lat = ''
        this.lng = ''
      }
      this.keepCurrentLocation = false
      if (!this.searchLocation) {
        this.initAutoCompleteSearch()
      }
    },
    msgLocalization: function (val) {
      if (val && !this.hasDisposition) {
        setTimeout(() => {
          document.getElementById('errorLocalisation').scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'center'
          })
        }, 300)
      }
    },
    choiceDay: function (newValue, oldValue) {
      if (this.choiceDay) {
        const orderType = this.orderType || this.$disposition.getByKey(this, 'orderType', 'D').charAt(0)
        const obj = this.objTime[this.choiceDay]
        this.dataTime = this.checkASAP(obj, this.choiceDay, orderType && orderType.toUpperCase() === 'C')
        const now = moment.tz(new Date(), obj.timezone)
        if (now.format('YYYY-MM-DD') === this.choiceDay && this.dataTime.length === 0) {
          this.dataDate = this.dataDate.filter(item => item.value !== this.choiceDay)
          this.choiceDay = this.getValueFromAttr(this.dataDate, '0.value')
          return
        }
        const collectionTime = this.$disposition.getByKey(this, 'collectionTime', {}) || {}
        const time = this.choiceHour || (collectionTime && collectionTime.pickedHours)
        const check = time ? this.dataTime.filter(item => item.value === time) : []
        this.choiceHour = check && check.length > 0 ? time : this.getValueFromAttr(this.dataTime, '0.value')
        if (this.objTime[this.choiceDay]) {
          this.timezone = this.objTime[this.choiceDay].timezone
        }
      }
    }
  },
  data () {
    return {
      keepCurrentLocation: false,
      deliveryInfo: {
        location: '',
        city: '',
        state: '',
        streetName: '',
        streetNumber: '',
        postalCode: ''
      },
      customerInfo: {
        list_address: [],
        list_store: []
      },
      highlight: null,
      locationCenter: {lat: 0, lng: 0},
      searchLocation: false,
      isDeliveryClass: this.getClasses(true),
      isCollectionClass: this.getClasses(false),
      orderType: this.$const.DELIVERY,
      searchAutoComplete: '',
      outletList: [],
      isSearchAddress: false,
      result: {},
      message: '',
      geocoder: {},
      map: {},
      marker: {},
      markers: [],
      addressAutoComplete: false,
      addressSelected: '',
      mapOpen: false,
      hasDisposition: this.checkPosition(this),
      showMapDelivery: false,
      lat: 0,
      lng: 0,
      currentLocation: false,
      addressDelivery: '',
      timezone: null,
      choiceDay: '',
      choiceHour: '',
      dataDate: [],
      dataTime: [],
      objTime: null,
      showPopupTime: false,
      switchToDelivery: false,
      switchToCollection: false,
      msgLocalization: '',
      msgGeo: ''
    }
  },
  mounted () {
    const vm = this
    const keyGoogleMapAPI = this.$session.get('google-key-api')
    this.loadScriptMap(keyGoogleMapAPI, this.$const.DEFAULT_LANGUAGE, this.$const.COUNTRY_CODE)
    window.infowindowClick = function (index) {
      vm.infowindowClick(index)
    }

    this.$root.$on('onCheckValidOutlet', (_data) => {
      vm.checkValidOutlet()
    })

    this.$root.$on('search', (data) => {
      vm.keepCurrentLocation = true
      vm.searchAutoComplete = data.address
      vm.lat = data.lat
      vm.lng = data.lng
      vm.handleCallbackMapDelivery(data.lat, data.lng)
    })

    this.$root.$on('closeDispositionPopup', () => {
      vm.$emit('close')
    })

    this.$root.$on('onChangeOutlet', (index) => {
      vm.onChangeOutlet(index)
    })

    this.$root.$on('onclickChosenOutlet', (outlet) => {
      vm.orderType = this.$cart.order_type === 'D' ? vm.$const.DELIVERY : vm.$const.CARRYOUT
      vm.clickChosenOutlet(outlet)
    })

    this.$root.$on('activeCollectionMap', () => {
      vm.searchAutoComplete = vm.addressSelected ? vm.addressSelected : vm.searchAutoComplete
      vm.clickActiveCollection(vm.searchAutoComplete.length > 0)
      vm.searchLocation = true
      vm.getLatLng()
    })

    this.$root.$on('clearAndCreateNewStore', (outlet) => {
      vm.$cart.removeCart(vm)
      vm.clickChosenOutlet(outlet)
    })

    this.$root.$on('activeTabLocalization', (type) => {
      if (type === vm.$const.DELIVERY) {
        vm.clickActiveDelivery()
      } else if (type === vm.$const.CARRYOUT) {
        vm.clickActiveCollection()
      }
    })

    this.$disposition.init(this)
    this.addEventTrackLocalization()
    this.initGeocoder()
    this.initAutoCompleteSearch()
    this.checkGeoLocationPermission()

    if (this.$auth.check()) {
      this.initializeSaveAddress()
    }
    if (vm.$root.$route.query.orderTypeDefault && vm.$root.$route.query.orderTypeDefault === 'collection') {
      this.clickActiveCollection()
    } else {
      this.clickActiveDelivery()
    }
    if (this.$route.query.store_code) {
      this.localisationDirectlyTakeaway(this.$route.query.store_code)
    }
    if (this.hasDisposition) {
      this.eventTrackingAutoLocalised()
    }
    if (this.isSubCategory) {
      let lastOrderType = this.$disposition.getByKey(this, 'orderType', '')
      this.clearDisposition()
      this.$root.$emit('onReInitHeader')
      if (lastOrderType === this.$const.DELIVERY) {
        this.clickActiveCollection()
      } else {
        this.clickActiveDelivery()
      }
    }
  },
  beforeDestroy () {
    this.$root.$off('onCheckValidOutlet')
    this.$root.$off('onChangeOutlet')
    this.$root.$off('onclickChosenOutlet')
    this.$root.$off('activeCollectionMap')
    this.$root.$off('search')
    this.$root.$off('activeTabLocalization')
  },
  methods: {
    ...mapActions({
      setDisposition: action.SET_DISPOSITION,
      setWarningDisposition: action.SET_WARNING_DISPOSITION,
      setShowModalTakeAwayLess: action.SET_SHOW_MODAL_TAKE_AWAY_LESS
    }),
    loadScriptMap (keyAPI, language, country) {
      (function (d, s, id) {
        let js = null
        const fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) return
        js = d.createElement(s)
        js.id = id
        js.async = true
        js.src = 'https://maps.googleapis.com/maps/api/js?key=' + keyAPI + '&libraries=places&language=' + language + '&region=' + country
        fjs.parentNode.insertBefore(js, fjs)
      }(document, 'script', 'google-maps-jssdk'))
    },
    getClasses (isActive) {
      return isActive ? 'xs-fill-white xs-text-red xs-relative xs-z-200 xs-py-15' : 'xs-fill-gray-lightest xs-text-gray-medium xs-grayscale'
    },
    addEventTrackLocalization () {
      let layer = {
        'assets': {
          'tools': [
            {
              'id': 'localisation-delivery',
              'type': 'storefinder',
              'name': 'delivery-tab',
              'attributes': {
                'function': 'show-delivery-tab'
              }
            },
            {
              'id': 'localisation-takeaway',
              'type': 'storefinder',
              'name': 'takeaway-tab',
              'attributes': {
                'function': 'show-takeaway-tab'
              }
            },
            {
              'id': 'localisation-auto',
              'type': 'storefinder',
              'name': 'auto-locate-button',
              'attributes': {
                'function': 'auto-locate-user'
              }
            }
          ]
        }
      }
      this.eventTrackingModule(layer)
    },
    checkGeoLocationPermission () {
      let vm = this
      navigator.permissions.query({
        name: 'geolocation'
      }).then(function (result) {
        if (result.state === 'granted') {
        } else if (result.state === 'prompt') {
          vm.msgGeo = vm.$t('geo_notification_message')
        } else if (result.state === 'denied') {
          vm.msgLocalization = vm.$t('geo_notificaton_blocked')
        }
      })
    },
    useMyLocation () {
      const vm = this
      this.eventFindMyLocation()
      vm.searchLocation = true
      vm.isSearchAddress = true
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function (position) {
          vm.isSearchAddress = false
          vm.getAddressByLatLog({
            lat: parseFloat(position.coords.latitude),
            lng: parseFloat(position.coords.longitude)
          })
          vm.searchByLocation(position.coords.latitude, position.coords.longitude)
          vm.locationCenter.lat = position.coords.latitude
          vm.locationCenter.lng = position.coords.longitude
        },
        function (error) {
          vm.isSearchAddress = false
          if (error.code === error.PERMISSION_DENIED) {
            vm.msgLocalization = vm.$t('message_geolocation_denied_1')
            vm.msgGeo = ''
          }
        })
      }
    },
    initializeSaveAddress () {
      const vm = this
      this.axios.apiCustomer.getProfile((response) => {
        let data = []
        for (let i in response.data.data.item.locations) {
          data.push({
            label: response.data.data.item.locations[i].house_no + ' ' + response.data.data.item.locations[i].location,
            code: response.data.data.item.locations[i]
          })
        }
        let dataStore = []
        for (let j in response.data.data.item.outlets) {
          dataStore.push({
            label: response.data.data.item.outlets[j].outlet_name,
            code: response.data.data.item.outlets[j]
          })
        }
        vm.customerInfo.list_address = data
        vm.customerInfo.list_store = dataStore
      })
    },
    selectSaveAddress (value) {
      if (!value) {
        return
      }
      this.lat = value.code.lat
      this.lng = value.code.long
      this.keepCurrentLocation = true
      this.searchAutoComplete = value.label
      this.addressAutoComplete = ''
      this.deliveryInfo = {
        city: value.code.city,
        streetNumber: value.code.house_no,
        streetName: value.code.street_name,
        state: value.code.state,
        postalCode: value.code.zip_code
      }
      this.searchOutletByLatLng()
    },
    localisationDirectlyTakeaway (code) {
      const vm = this
      vm.callEventBus(vm.$const.EVENT_BUS.LOADING, true)
      this.axios.apiOutlet.getOutLetByCode({code: code}, function (response) {
        vm.$session.remove('cart')
        vm.$session.remove('disposition')
        vm.$root.$emit('cartUpdate')
        vm.hasDisposition = false
        vm.result = {}
        let outletInfo = response.data.data.item
        vm.result.takeaWayLess = 1
        vm.result.outletId = outletInfo.id
        vm.result.orderType = vm.$const.CARRYOUT
        vm.orderType = vm.$const.CARRYOUT
        vm.result.lat = outletInfo.lat
        vm.result.long = outletInfo.long
        vm.result.outletAddress = outletInfo.address
        vm.result.outletName = outletInfo.name
        vm.result.outletCode = outletInfo.code
        vm.result.tier = outletInfo.tier
        vm.checkValidOutlet()
        vm.callEventBus(vm.$const.EVENT_BUS.LOADING, false)
      }, function (_error) {
        vm.callEventBus(vm.$const.EVENT_BUS.LOADING, false)
      })
    },
    viewMenu () {
      this.$store.commit('setCategoryUuid', null)
      if (this.routeLanding) {
        this.redirectToMenuPage('promos', 'cheesybites')
      } else {
        this.redirectToMenuPage()
      }
    },
    searchDelivery () {
      let vm = this
      this.msgLocalization = ''
      this.switchToDelivery = false
      this.switchToCollection = false
      if (this.orderType === this.$const.CARRYOUT) {
        this.clickActiveCollection()
      } else {
        if (vm.isMobile()) {
          let geocoder = new google.maps.Geocoder()
          geocoder.geocode({'address': vm.searchAutoComplete}, function (results, status) {
            if (status === 'OK') {
              vm.$modal.show(ModalMapDelivery, {
                lat: results[0].geometry.location.lat(),
                lng: results[0].geometry.location.lng(),
                address: vm.searchAutoComplete
              })
            }
          })
        } else {
          vm.clearTimeSlot()
          vm.getLagLngByAddress()
        }
      }
    },
    searchOutletByLatLng () {
      const vm = this
      const lat = vm.lat
      const lng = vm.lng
      if (!lng || !lat) {
        vm.switchToCollection = true
        vm.switchToDelivery = false
        vm.msgLocalization = vm.$t('modal.delivery_message')
        return false
      }
      let val = lng + ',' + lat
      let data = {location: val, disposition: 'D', limit: 10}
      vm.message = ''
      vm.axios.apiOutlet.checkLocation(data, function (response) {
        vm.searchLocation = false
        vm.outletList = response.data.data.items
        if (vm.outletList.length <= 0) {
          vm.evenTrackingNotInDeliveryZone(vm.searchAutoComplete, lat, lng)
          vm.switchToCollection = true
          vm.switchToDelivery = false
          vm.msgLocalization = vm.$t('modal.delivery_message')
        } else {
          if (vm.orderType === vm.$const.DELIVERY) {
            vm.lat = lat
            vm.lng = lng
            vm.setDataForDelivery(vm.outletList[0])
          }
        }
      }, function (error) {
        console.log(`error: ${error}`)
        vm.evenTrackingNotInDeliveryZone(vm.searchAutoComplete, lat, lng)
        vm.switchToCollection = true
        vm.switchToDelivery = false
        vm.msgLocalization = vm.$t('modal.delivery_message')
      })
    },
    setDataForDelivery (obj) {
      this.result.outletAddress = obj.address
      this.result.orderType = this.orderType
      this.result.locationName = obj.address
      this.result.cityName = obj.city_name
      this.result.villeageName = obj.villeage_name
      this.result.st = obj.st
      this.result.outletId = obj.id
      this.checkValidOutlet()
    },
    handleCallbackMapDelivery (lat, lng, triggerOrderNow = true) {
      let vm = this
      const geocoder = new google.maps.Geocoder()
      let latlng = {lat: lat, lng: lng}
      geocoder.geocode({'location': latlng}, function (results, status) {
        if (status === 'OK') {
          if (results && results[0]) {
            vm.lat = lat
            vm.lng = lng
            vm.setDeliveryInfo(results[0])
          }
        }
        if (triggerOrderNow) {
          vm.orderNow()
        }
      })
    },
    orderNow () {
      this.showMapDelivery = false
      this.$cart.order_type = 'D'
      this.searchOutletByLatLng()
    },
    getAddress (lat, lng) {
      let vm = this
      vm.lat = lat
      vm.lng = lng
      const geocoder = new google.maps.Geocoder()
      let latlng = {lat: lat * 1, lng: lng * 1}
      geocoder.geocode({'location': latlng}, function (results, status) {
        if (status === 'OK') {
          if (results && results[0]) {
            vm.setDeliveryInfo(results[0])
            vm.keepCurrentLocation = true
            vm.searchAutoComplete = results[0].formatted_address
          }
        }
      })
    },
    setDeliveryInfo (data) {
      let vm = this
      const componentForm = {
        street_number: 'short_name',
        route: 'long_name',
        sublocality_level_1: 'long_name',
        locality: 'long_name', // city
        administrative_area_level_1: 'short_name', // state
        country: 'long_name',
        postal_code: 'short_name'
      }
      let subLocal = ''
      if (data && data.hasOwnProperty('address_components')) {
        for (let i = 0; i < data.address_components.length; i++) {
          const addressType = data.address_components[i].types[0]
          if (componentForm[addressType]) {
            componentForm[addressType] = data.address_components[i][componentForm[addressType]]
          } else if (addressType === 'political' && data.address_components[i].types.length >= 3 && data.address_components[i].types[2] === 'sublocality_level_1') {
            subLocal = data.address_components[i].long_name
          }
        }
      }
      if (componentForm.route !== 'long_name' && subLocal.length > 0) {
        componentForm.route += ', ' + subLocal
      }
      let sublocality = componentForm.sublocality_level_1 !== 'long_name' ? ', ' + componentForm.sublocality_level_1 : ''
      vm.deliveryInfo = {
        city: componentForm.locality !== 'long_name' ? componentForm.locality : '',
        streetNumber: componentForm.street_number !== 'short_name' ? componentForm.street_number : '',
        streetName: componentForm.route !== 'long_name' ? componentForm.route + sublocality : '',
        state: componentForm.administrative_area_level_1 !== 'short_name' ? componentForm.administrative_area_level_1 : '',
        postalCode: componentForm.postal_code !== 'short_name' ? componentForm.postal_code : ''
      }
    },
    clickActiveDelivery () {
      this.addressAutoComplete = false
      this.orderType = this.$const.DELIVERY
      this.isDeliveryClass = this.getClasses(true)
      this.isCollectionClass = this.getClasses(false)
      this.outletList = []
      this.message = ''
      this.msgLocalization = ''
      this.switchToDelivery = false
      this.showPopupTime = false
      this.clearTimeSlot()
      if (this.showMapDelivery) {
        this.searchAutoComplete = this.addressDelivery
        this.openGGMapWithAddress(this.lat, this.lng)
      }
      this.$session.set('orderType', this.$const.DELIVERY)
    },
    clickActiveCollection (ignore = false) {
      this.addressDelivery = this.searchAutoComplete
      this.orderType = this.$const.CARRYOUT
      this.isDeliveryClass = this.getClasses(false)
      this.isCollectionClass = this.getClasses(true)
      this.outletList = []
      this.message = ''
      this.msgLocalization = ''
      this.switchToCollection = false
      this.showMapDelivery = false
      this.showPopupTime = false
      this.clearTimeSlot()
      if (this.searchAutoComplete && !ignore) {
        this.getLatLng()
      }
      this.$session.set('orderType', this.$const.CARRYOUT)
    },
    clearTextSearch () {
      this.switchToDelivery = false
      this.switchToCollection = false
      this.showMapDelivery = false
      this.searchAutoComplete = ''
      this.message = ''
      this.msgLocalization = ''
      this.outletList = []
      this.clearTimeSlot()
    },
    clearTimeSlot () {
      this.dataTime = []
      this.dataDate = []
      this.choiceDay = null
      this.objTime = null
    },
    resetDisposition () {
      const vm = this
      const lastOrderType = this.$disposition.getByKey(this, 'orderType', '')
      vm.setWarningDisposition(false)
      vm.$modal.show('dialog', {
        text: vm.$t('confirm_change_disposition'),
        buttons: [
          {
            title: vm.$t('button_yes'),
            handler: () => {
              vm.$modal.hide('dialog')
              vm.clearDisposition()
              if (lastOrderType === this.$const.CARRYOUT) {
                this.clickActiveCollection()
              }
              vm.$root.$emit('closePopUpClosing')
              vm.$root.$emit('updateHasDisposition', false)
            }
          },
          {
            title: vm.$t('button_close')
          }
        ]
      })
    },
    clearDisposition () {
      this.$session.remove('cart')
      this.$session.remove('disposition')
      this.setDisposition({})
      this.addCustomEvent('ABANDON_CART', 'ABANDON CART')
      this.$root.$emit('cartUpdate')
      this.hasDisposition = false
    },
    // GOOGLE MAP
    initGGMap (id, location, isFullScreen = false) {
      const map = new google.maps.Map(document.getElementById(id), {
        zoom: 15,
        center: location,
        streetViewControl: false,
        fullscreenControl: isFullScreen,
        rotateControl: false
      })
      return map
    },
    beforeOpen (_event) {
      this.map = this.initGGMap('mapLocalization', {lat: this.$const.GEO.POSITION.LAT, lng: this.$const.GEO.POSITION.LNG})
      this.drawMaps()
      this.onChangeOutlet(0)
      document.body.classList.add('modal-open')
    },
    beforeClose (_event) {
      this.mapOpen = false
      document.body.classList.remove('modal-open')
    },
    showHideMap (flag) {
      this.mapOpen = !flag
      if (this.mapOpen) {
        this.$modal.show(ModalMap, {outletList: this.outletList}, {height: 'auto'}, {
          'opened': this.beforeOpen,
          'before-close': this.beforeClose
        })
      } else {
        this.$root.$emit('onCloseMap')
      }
    },
    initAutoCompleteSearch () {
      const vm = this
      let element = document.getElementById('address-autocomplete')
      if (typeof google !== 'undefined' && typeof (element) !== 'undefined' && element !== null && !this.addressAutoComplete) {
        this.addressAutoComplete = new google.maps.places.Autocomplete(
          (document.getElementById('address-autocomplete')),
          {
            componentRestrictions: {country: this.$const.COUNTRY_CODE},
            fields: ['place_id', 'geometry', 'address_components']
          }
        )
        this.addressAutoComplete.setFields(['place_id', 'geometry', 'address_components'])
        this.addressAutoComplete.addListener('place_changed', () => {
          let place = this.addressAutoComplete.getPlace()
          vm.searchAutoComplete = document.getElementById('address-autocomplete').value
          if (!place) {
            return
          }
          let lat = place.geometry.location.lat()
          let lng = place.geometry.location.lng()
          vm.lat = lat
          vm.lng = lng
          vm.deliveryInfo = {
            city: '',
            state: '',
            streetNumber: '',
            streetName: '',
            postalCode: ''
          }
          vm.eventLocalisationStart()
          if (vm.orderType === vm.$const.CARRYOUT) {
            vm.clickActiveCollection()
          } else {
            vm.setDeliveryInfo(place)
            vm.searchOutletByLatLng()
          }
        })
      } else {
        vm.outletList = []
      }
    },
    openGGMapWithAddress (lat, lng) {
      let vm = this
      const location = {lat: lat, lng: lng}
      vm.showMapDelivery = vm.showMapDelivery ? vm.showMapDelivery : !vm.showMapDelivery
      const map = this.initGGMap('map-delivery', location)
      const marker = new google.maps.Marker({
        position: location,
        map: map,
        draggable: true,
        animation: google.maps.Animation.DROP
      })
      marker.addListener('drag', (event) => {
        vm.getAddress(event.latLng.lat(), event.latLng.lng())
      })
    },
    openGGMap () {
      const vm = this
      this.eventFindMyLocation()
      vm.isSearchAddress = true
      navigator.geolocation.getCurrentPosition(function (position) {
        const lat = position.coords.latitude
        const lng = position.coords.longitude
        vm.lat = lat
        vm.lng = lng
        const location = {lat: lat, lng: lng}
        vm.currentLocation = true
        vm.isSearchAddress = false
        if (vm.isMobile()) {
          vm.$bus.$emit('loading', 'none')
          vm.$modal.show(ModalMapDelivery, {lat: lat, lng: lng, address: ''})
        } else {
          vm.showMapDelivery = vm.showMapDelivery ? vm.showMapDelivery : !vm.showMapDelivery
          const map = vm.initGGMap('map-delivery', location)
          const marker = new google.maps.Marker({
            position: location,
            map: map,
            draggable: true
          })
          vm.getAddress(lat, lng)
          marker.addListener('drag', (event) => {
            vm.getAddress(event.latLng.lat(), event.latLng.lng())
          })
        }
      },
      function (error) {
        vm.isSearchAddress = false
        if (error.code === error.PERMISSION_DENIED) {
          vm.msgLocalization = vm.$t('message_geolocation_denied_1')
        }
      })
    },
    infowindowClick (index) {
      let outlet = this.outletList[index]
      this.clickChosenOutlet(outlet)
    },
    onChangeOutlet (index) {
      let flag = false
      if (this.locationCenter.lat !== 0 && this.locationCenter.lng !== 0) {
        flag = true
        index += 1
      }
      for (let i in this.markers) {
        if (Number(i) === 0 && flag) continue
        let url = this.markers[i].originIcon
        if (Number(i) === index) {
          url = this.markers[i].hoverIcon
        }
        this.markers[i].setIcon({
          url: url,
          scaledSize: new google.maps.Size(40, 40)
        })
      }
      if (this.markers.length > 0) {
        this.map.panTo(this.markers[index].position)
      }
    },
    initGeocoder () {
      if (typeof google !== 'undefined') {
        this.geocoder = new google.maps.Geocoder()
      }
    },
    getAddressByLatLog (latLong) {
      const vm = this
      vm.locationCenter.lat = latLong.lat
      vm.locationCenter.lng = latLong.lng
      this.initGeocoder()
      vm.searchLocation = true
      this.geocoder.geocode({'location': latLong}, function (results, status) {
        if (status === 'OK') {
          if (results[0]) {
            vm.searchAutoComplete = results[0].formatted_address
          }
        }
      })
    },
    getLatLng () {
      const vm = this
      let geocoder = new google.maps.Geocoder()
      geocoder.geocode({'address': this.searchAutoComplete}, function (results, status) {
        if (status === 'OK') {
          let lat = results[0].geometry.location.lat()
          let lng = results[0].geometry.location.lng()
          vm.searchByLocation(lat, lng)
        }
      })
    },
    beforeClickChosenOutlet (outlet) {
      let vm = this
      if (vm.$cart.getDetail(vm)) {
        vm.$modal.show(ModalConfirm, {outlet: outlet})
      } else {
        this.$cart.order_type = 'C'
        vm.clickChosenOutlet(outlet)
      }
    },
    clickChosenAddress (outlet) {
      this.result = {}
      if (outlet) {
        if (this.orderType === this.$const.DELIVERY) {
          this.addressSelected = this.searchAutoComplete
          if (outlet.code && outlet.code.trim().length > 0) {
            this.result.outletAddress = outlet.address
            this.result.orderType = this.$const.DELIVERY
            this.result.locationName = outlet.address
            this.result.cityName = outlet.city_name
            this.result.villeageName = outlet.villeage_name
            this.result.st = outlet.st
            this.result.outletId = outlet.id
          } else {
            let geocoder = new google.maps.Geocoder()
            const vm = this
            geocoder.geocode({'address': this.searchAutoComplete}, function (results, status) {
              if (status === 'OK') {
                const lat = results[0].geometry.location.lat()
                const lng = results[0].geometry.location.lng()

                if (!lng || !lat) {
                  vm.switchToCollection = true
                  vm.switchToDelivery = false
                  vm.msgLocalization = vm.$t('modal.delivery_message')
                  return false
                }
                let val = lng + ',' + lat
                let data = {location: val, order_type: 'C', limit: 5}
                vm.message = ''
                vm.axios.apiOutlet.checkLocation(data, function (response) {
                  vm.searchLocation = false
                  vm.outletList = response.data.data.items
                  if (vm.outletList.length <= 0) {
                    vm.evenTrackingNotInDeliveryZone(vm.searchAutoComplete, lat, lng)
                    vm.switchToCollection = true
                    vm.switchToDelivery = false
                    vm.msgLocalization = vm.$t('modal.delivery_message')
                  } else {
                    vm.$modal.show(ModalCarryout, {
                      methodSearch: vm.$const.DEFAULT_CONFIG_APP,
                      outletList: vm.outletList
                    })
                  }
                }, function (error) {
                  vm.evenTrackingNotInDeliveryZone(vm.searchAutoComplete, lat, lng)
                  console.log(`error: ${error}`)
                  vm.switchToCollection = true
                  vm.switchToDelivery = false
                  vm.msgLocalization = vm.$t('modal.delivery_message')
                })
              }
            })
          }
        } else {
          this.searchLocation = true
          this.searchAutoComplete = outlet.address
          this.getLatLng()
        }
      }
    },
    getLagLngByAddress () {
      let vm = this
      if (!vm.searchAutoComplete) {
        return
      }
      let geocoder = new google.maps.Geocoder()
      geocoder.geocode({'address': vm.searchAutoComplete}, function (results, status) {
        if (vm.lat || vm.lng || (results && results.length > 0)) {
          let lat = vm.lat ? vm.lat : results[0].geometry.location.lat()
          let long = vm.lng ? vm.lng : results[0].geometry.location.lng()
          vm.setDeliveryInfo(results[0])
          if (!vm.lng || !vm.lat) {
            vm.lng = long
            vm.lat = lat
          }
          if (status === 'OK') {
            if (vm.isMobile()) {
              vm.$modal.show(ModalMapDelivery, {
                lat: results[0].geometry.location.lat(),
                lng: results[0].geometry.location.lng(),
                address: vm.searchAutoComplete
              })
            } else {
              vm.openGGMapWithAddress(lat, long)
              vm.handleCallbackMapDelivery(lat, long, false)
            }
          }
        }
      })
    },
    _processValidOutlet (response) {
      let vm = this
      let lat = vm.lat
      let long = vm.lng
      let data = vm.$disposition.get(vm)
      // set data
      data.prefectureName = ''
      data.cityName = ''
      data.villeageName = ''
      data.st = ''
      data.lat = lat
      data.long = long
      data.postalCode = response.zip || vm.deliveryInfo.postalCode
      if (vm.orderType === vm.$const.DELIVERY) {
        data.locationName = vm.searchAutoComplete
        data.prefectureName = vm.deliveryInfo.state || ''
        data.cityName = vm.deliveryInfo.city || ''
        data.villeageName = vm.deliveryInfo.streetName || ''
        data.st = vm.deliveryInfo.streetNumber || ''
      } else {
        data.locationName = vm.result.locationName
      }
      data.minCart = response.min_cart
      data.outletAddress = response.address
      data.orderType = vm.result.orderType
      data.outletId = response.id
      data.outletName = response.name
      data.outletCode = response.code
      data.advanceOrder = vm.$disposition.getByKey(vm, 'advanceOrder', 0) || 0
      data.tier = response.tier
      data.takeaWayLess = vm.result.orderType === vm.$const.CARRYOUT ? (vm.result.takeaWayLess || 0) : 0
      data.customize = response.customize
      vm.$disposition.set(vm, data)
      vm.showHideMap(true)
      vm.addCustomEvent(vm.result.orderType, vm.result.orderType)
      vm.eventTrackingLocalisationSuccess(vm)
      if (data.takeaWayLess) {
        vm.setShowModalTakeAwayLess(vm.$const.SHOW_POPUP_QR)
      }
      if (vm.$route.query && vm.$route.query.callback) {
        vm.$router.push(vm.$route.query.callback)
      } else if (vm.routeLanding) {
        vm.redirectToMenuPage('promos', 'cheesybites')
      } else if (vm.isPopup) {
        vm.$emit('close')
        if (vm.callBackNameSeo) {
          vm.$root.$router.push({name: 'combo-detail', params: {nameseo: vm.callBackNameSeo}})
        } else {
          window.location.reload(true)
        }
      } else {
        vm.$root.$emit('onProcessChangeCategory')
      }
      vm.$root.$emit('showPopUpClosing')
    },
    checkValidOutlet () {
      const vm = this
      const lat = vm.lat
      const long = vm.lng
      if (vm.orderType === vm.$const.DELIVERY && !vm.deliveryInfo.streetName) {
        vm.msgLocalization = vm.$t('miss_streetName')
        vm.openGGMapWithAddress(lat, long)
        return false
      }
      let data = {
        order_type: this.orderType.charAt(0),
        order_time: this.convertDateTimeFromTimezoneToUTC(this.$disposition.getByKey(this, 'timezone', ''), this.$disposition.getByKey(this, 'collectionTimeText', '')),
        advance_order: this.$disposition.getByKey(this, 'advanceOrder', 0) || 0,
        outlet_id: this.result.outletId,
        address: this.searchAutoComplete ? this.searchAutoComplete : '',
        lat: lat,
        long: long
      }
      this.axios.apiOutlet.checkOutletAvailable(data, function (response) {
        if (response.data.status && response.data.data && response.data.data.item) {
          const item = response.data.data.item
          if (!item.warning_reason || !item.warning_reason.code) {
            vm._processValidOutlet(item)
          } else {
            const errorCode = item.warning_reason.code || '001'
            let message = vm.getTextInErrorMessage(errorCode) || (item.warning_reason && item.warning_reason.message)
            vm.$modal.show(ModalWarning, {
              title: 'Warning',
              outlet: item,
              message: message,
              closeCallBack: function (data) {
                vm._processValidOutlet(data)
              }
            })
          }
        } else if (response.data.message) {
          vm.$notify({
            type: 'warn',
            title: response.data.message
          })
        }
      },
      function (error) {
        const message = vm.getMessageFromGms(error)
        error = error.error
        // let _lat = vm.lat || vm.locationCenter.lat
        // let _lng = vm.lng || vm.locationCenter.lng
        vm.msgLocalization = message
        vm.eventTrackingLocalisationError({id: 'error-localization', error: 'invalid-localisation'})
        vm.eventTrackingFailureLocalised()
        // let _data = vm._.cloneDeep(vm.result)
        // if (!_data.lat || !_data.lng) {
        //   _data.lat = _lat
        //   _data.long = _lng
        // }
        /* DEAD TRACKING */
        if (vm.$const.LOCALIZATION_CODE.DELIVERY_DEADZONE.indexOf(error.code) > -1) {
          vm.eventTrackingDeliveryDeadZone('UnAvailable')
        } else if (vm.$const.LOCALIZATION_CODE.HUT_CLOSED.indexOf(error.code) > -1) {
          vm.eventTrackingHutClosed(data.outlet_id)
        } else if (vm.$const.LOCALIZATION_CODE.HUT_BOUNCING.indexOf(error.code) > -1) {
          vm.evenTrackingHutIsBouncing(data.outlet_id)
        }

        if (vm.$const.MESSAGES_CODE.STOP_DELIVERY_TOTAL.indexOf(error.code) > -1 ||
          vm.$const.MESSAGES_CODE.STOP_TOTAL_WITH_TIME_RANGE.indexOf(error.code) > -1 ||
          vm.$const.MESSAGES_CODE.STOP_TOTAL_WITH_TIME_RANGE.indexOf(error.code) > -1 ||
          error.code === vm.$const.LOCALIZATION_CODE.STORECLOSE ||
          error.code === vm.$const.LOCALIZATION_CODE.CLOSESTORE) {
          vm.showPopupTime = true
        } else if (vm.$const.MESSAGES_CODE.STOP_DELIVERY_WITHOUT_TIME_RANGE_HAS_REASON.indexOf(error.code) > -1) {
          vm.switchToCollection = true
          vm.switchToDelivery = false
        } else if (vm.$const.MESSAGES_CODE.STOP_TOTAL_WITH_TIMEOUT_RANGE.indexOf(error.code) > -1) {
          vm.switchToCollection = false
          vm.switchToDelivery = false
        } else if (vm.orderType.charAt(0) === 'D') {
          vm.switchToCollection = true
          vm.switchToDelivery = false
        } else {
          vm.switchToCollection = false
          vm.switchToDelivery = true
        }
        /* END */
      }
      )
    },
    searchByLocation (lat, lng) {
      this.locationCenter.lat = lat
      this.locationCenter.lng = lng
      this.outletList = []
      if (!lng || !lat) {
        return false
      }
      let val = lng + ',' + lat
      let data = {location: val, order_type: this.orderType.charAt(0), limit: 5}
      if (this.orderType.charAt(0) === 'D') {
        data = {location: val, disposition: this.orderType.charAt(0), limit: 5}
      }
      const vm = this
      vm.message = ''
      vm.axios.apiOutlet.checkLocation(data, function (response) {
        vm.searchLocation = false
        let resData = response.data.data.items
        if (vm.orderType.charAt(0) === 'D') {
          if (resData.length <= 0) {
            // call api for incase carryout
            vm.axios.apiOutlet.checkLocation({
              limit: data.limit,
              location: data.location,
              order_type: 'C'
            }, function (response) {
              let resData = response.data.data.items
              if (resData.length > 0) {
                if (vm.orderType === vm.$const.DELIVERY) {
                  vm.setDataForDelivery(vm.outletList[0])
                }
              } else {
                vm.switchToCollection = true
                vm.switchToDelivery = false
                vm.msgLocalization = vm.$t('modal.delivery_message')
              }
            }, function (error) {
              vm.searchLocation = false
              console.log(`error: ${error}`)
              vm.message = vm.$t('localization.stores_404')
            })
          } else {
            vm.beforeClickChosenOutlet(resData[0])
          }
        } else {
          if (resData.length <= 0) {
            vm.message = vm.$t('localization.stores_404')
          } else {
            vm.outletList = response.data.data.items
          }
        }
      }, function (error) {
        vm.searchLocation = false
        console.log(`error: ${error}`)
        vm.message = vm.$t('localization.stores_404')
      })
    },
    drawMaps () {
      const vm = this
      for (let i = 0; i < this.markers.length; i++) {
        this.markers[i].setMap(null)
      }
      this.markers = []
      if (this.locationCenter.lat !== 0 && this.locationCenter.lng !== 0) {
        let latlng = new google.maps.LatLng(this.locationCenter.lat, this.locationCenter.lng)
        let nMarket = new google.maps.Marker({
          position: latlng,
          map: this.map,
          draggable: false,
          icon: 'https://static.phdvasia.com/jp/icons/pin.png'
        })
        this.markers.push(nMarket)
      }

      let bounds = new google.maps.LatLngBounds()
      bounds.extend(new google.maps.LatLng(this.markers[0].getPosition().lat(), this.markers[0].getPosition().lng()))
      for (let i = 0; i < this.outletList.length; i++) {
        let latlng = new google.maps.LatLng(this.outletList[i].lat, this.outletList[i].long)
        let icon = {
          url: 'https://static.phdvasia.com/jp/icons/gray-logo.png',
          scaledSize: new google.maps.Size(40, 40)
        }
        let contentString = '<div id="content">' +
            '<div id="siteNotice">' +
            '</div>' +
            '<h2 id="firstHeading" class="firstHeading mt-10">' + this.outletList[i].name + '</h2>' +
            '<div id="bodyContent">' +
            '<p>' + this.outletList[i].address + '</p>' +
            '<p class="mb-0"><button class="btn btn-success maps-infowindow t13 " style="padding: 8px 20px" onclick="infowindowClick(' + i + ')">' + this.$t('select') + '</button></p>' +
            '</div>' +
            '</div>'

        let marker = new google.maps.Marker({
          position: latlng,
          map: this.map,
          draggable: false,
          outletIndex: i,
          outlet: this.outletList[i],
          infowindow: new google.maps.InfoWindow({
            content: contentString
          }),
          title: this.outletList[i].address,
          icon: icon,
          hoverIcon: 'https://static.phdvasia.com/my/icons/red-logo.png',
          originIcon: 'https://static.phdvasia.com/jp/icons/gray-logo.png'
        })
        this.markers.push(marker)
        if (this.outletList[i].distance <= 10) {
          bounds.extend(new google.maps.LatLng(this.markers[i].getPosition().lat(), this.markers[i].getPosition().lng()))
        }
        marker.addListener('mouseover', function (_e) {
          this.highlight = this.outletIndex
        })
        marker.addListener('click', function (_e) {
          for (let i = 0; i < vm.markers.length; i++) {
            if (vm.markers[i].infowindow) {
              vm.markers[i].infowindow.close()
            }
          }
          vm.onChangeOutlet(this.outletIndex)
          this.infowindow.open(this.map, marker)
        })
        marker.addListener('mouseout', function (_e) {
          this.highlight = null
        })
      }
      this.map.fitBounds(bounds)
    },
    // TIME SLOT
    handleAction () {
      if (this.showPopupTime) {
        this.initializeTimeSlot()
        this.resetErrorAction()
      }
    },
    initializeTimeSlot () {
      const vm = this
      let id = 0
      if (typeof this.result.outletId !== 'undefined' && this.result.outletId) {
        id = this.result.outletId
      } else if (!this.empty(this.$disposition.getByKey(this, 'outletId', ''))) {
        id = this.$disposition.getByKey(this, 'outletId', '')
      }
      let orderType = this.orderType || this.$disposition.getByKey(this, 'orderType', 'D').charAt(0)
      const params = {
        outletId: id,
        order_type: orderType.charAt(0),
        subtradezoneid: this.$disposition.getByKey(this, 'subtradezoneid', '')
      }
      this.axios.apiOutlet.getOutletOpeningHours(params, function (response) {
        let items = response.data.data.items
        if (!vm.empty(items)) {
          vm.dataDate = vm.generateDateOrder(items)
          vm.objTime = vm.generateTimeOrder(items)
          const collectionTime = vm.$disposition.getByKey(vm, 'collectionTime', {}) || {}
          vm.choiceDay = collectionTime.pickedDay || vm.getValueFromAttr(vm.dataDate, '0.value')
        }
      }, function (error) {
        const message = vm.getMessageFromGms(error)
        vm.msgLocalization = message
      })
    },
    selectTimeSlot () {
      const timepicker = {'pickedDay': this.choiceDay, 'pickedHours': this.choiceHour}
      let data = this.$disposition.get(this)
      data.collectionTime = timepicker
      data.collectionTimeText = this.choiceDay + ' ' + this.choiceHour
      let time = this.choiceHour.split(' - ')
      if (time.length > 1) {
        time = time[1]
      } else if (time.length > 0) {
        time = time[0]
      }
      data.collectionTimeValue = this.choiceDay + ' ' + time
      data.timezone = this.timezone
      data.advanceOrder = 1
      if (this.choiceHour === 'ASAP') {
        data.advanceOrder = 0
      }
      this.$disposition.set(this, data)
      // call api to update order time
      this.$cart.updateOrderTime(this, {'order_time': this.getTimePickerDate(this)})
      this.checkValidOutlet()
    },
    resetErrorAction () {
      this.msgLocalization = ''
      this.switchToCollection = false
      this.switchToDelivery = false
      this.showPopupTime = false
      this.$session.remove('cart')
      this.$session.remove('disposition')
    },
    changeAddress () {
      if (this.hasDisposition) {
        this.resetDisposition()
      } else {
        this.setWarningDisposition(true)
        this.lat = 0
        this.lng = 0
        this.clearTextSearch()
        this.$refs.autoComplete.focus()
      }
    },
    selectStore (value) {
      if (!value) {
        return
      }
      const vm = this
      vm.result = {}
      this.axios.apiOutlet.getOutLetByCode({code: value.code.outlet_code}, (response) => {
        let data = response.data.data.item
        if (data) {
          vm.clickChosenOutlet(data)
        } else {
          vm.$notify({
            type: 'warn',
            title: vm.$t('warning_store_invalid')
          })
        }
      })
    },
    clickChosenOutlet (outlet) {
      this.result = {}
      if (outlet) {
        this.result.lat = outlet.lat
        this.result.long = outlet.long
        this.result.outletAddress = outlet.address
        this.result.orderType = this.orderType
        this.result.outletId = outlet.id
        this.result.outletName = outlet.name
        this.result.outletCode = outlet.code
        this.result.tier = outlet.tier
        if (this.orderType === this.$const.DELIVERY) {
          this.clickChosenAddress(outlet)
        } else {
          this.showPopupTime = false
          this.clearTimeSlot()
          this.checkValidOutlet()
        }
      }
    }
  }
}
</script>
<style scoped>
  .container-outlet {
    max-height: 520px;
    overflow-y: auto;
  }

  .disposition-title {
    font-size: 15px;
  }

  @media (min-width: 768px) {
    .disposition-title {
      font-size: 18px;
    }
  }

  #mapLocalization {
    height: 238px;
    width: 100%;
  }

  @media screen and (min-width: 48em) {
    #mapLocalization {
      height: 455px;
    }
  }

  li.outlet-item:hover, .highlight {
    background: #3053691a;
  }

  .time-slots {
    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  .time-slots select {
    flex: 1;
    border: solid 1px #E5E5E5;
    margin-top: 5px;
    margin-bottom: 5px;
    border-radius: 5px;
    padding: 10px;
  }

  .time-slots select.arrow-dropdown-time {
    background-image: url(http://static.phdvasia.com/nz/icons/arrow_down.png);
    background-position: calc(100% - 16px) 1em, calc(100% - 16px) 1em, calc(100% - 2.5em) .5em;
    background-size: 12px;
    background-repeat: no-repeat;
  }

  .dropdown-label {
    color: #6B6E79;
    font-size: 12px;
  }

  .geo-message-content {
    display: flex;
    flex-direction: row;
    background-color: #FFF8E2;
    padding: 15px;
  }

  .geo-message-title {
    font-size: 22px;
    font-weight: 700;
  }

  .icon-noti-geo {
    line-height: 1.5;
    color: #FEBC3C;
    font-size: 20px;
  }

  .localization-timeslot-title {
    font-size: 20px;
    font-weight: 600;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/HomeLocalizationMapGoogleApiNewDesign.vue